import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import AdminSidebar from '@/components/admin/AdminSidebar';
import { Skeleton } from '@/components/ui/skeleton';
import { Link } from 'react-router-dom';

const AdminLayout = () => {
  const { user, role, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex">
        <div className="w-64 border-r bg-sidebar-background p-4">
          <div className="flex items-center gap-3 mb-8 px-2">
            <Skeleton className="h-5 w-20" />
            <Skeleton className="h-4 w-8" />
          </div>
          <div className="space-y-1">
            {Array.from({ length: 6 }).map((_, i) => (
              <Skeleton key={i} className="h-10 w-full rounded-md" />
            ))}
          </div>
        </div>
        <div className="flex-1">
          <div className="h-16 border-b flex items-center px-6">
            <Skeleton className="h-5 w-32" />
          </div>
          <div className="p-6 space-y-6">
            <Skeleton className="h-8 w-64" />
            <div className="grid gap-4 grid-cols-4">
              {Array.from({ length: 4 }).map((_, i) => (
                <Skeleton key={i} className="h-28 rounded-lg" />
              ))}
            </div>
            <div className="grid gap-6 grid-cols-2">
              <Skeleton className="h-64 rounded-lg" />
              <Skeleton className="h-64 rounded-lg" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }

  if (!role) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center p-4">
        <div className="text-center max-w-md">
          <div className="h-12 w-12 rounded-full bg-destructive/10 flex items-center justify-center mx-auto mb-4">
            <span className="text-destructive text-xl">!</span>
          </div>
          <h1 className="text-xl font-semibold mb-2">Access Pending</h1>
          <p className="text-muted-foreground mb-6 text-sm leading-relaxed">
            Your account has been created but you don't have access to the admin panel yet.
            Please contact an administrator to grant you access.
          </p>
          <Link
            to="/"
            className="text-sm text-primary hover:underline"
          >
            ← Back to website
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <AdminSidebar />
      <div className="ml-64">
        <Outlet />
      </div>
    </div>
  );
};

export default AdminLayout;
